// Shared config for the IRA integration partners (staff-only). Drives the
// config-driven loops in the account rewards and plan details worksheets so the
// three partners are no longer hardcoded 3x. `setupType` selects which fields a
// partner exposes: "partnership" => admin/setup-fee/spread fields; "reward" =>
// rewardAmount. Partner/setup-type values match the API enum strings.
//
// `dataIds` holds a stable 32-char id per (partner, interactive element). The Pc*
// inputs validate `data-id.length === 32`, so the looped bindings must use these
// fixed ids rather than template literals (which vary in length and break the
// validator + make QA selectors non-deterministic). Keys map to the elements each
// setupType renders: partnerships expose all 10; the reward partner only 6.
// TECH-12215: stable 32-char data-ids for the single-select "IRA Integration
// Partner" dropdown that replaces the per-partner checkboxes on plan create/edit.
// Plain v-selects don't enforce the 32-char rule the Pc* inputs do, but we keep
// fixed ids here so QA selectors stay deterministic (same rationale as the loop
// data-ids below).
export const iraIntegrationPartnerDataIds = {
  editSelect: "a1e5c7d9b3f04628a1c5e7d9b3f04628",
  createSelect: "b2f6d8e0c4a15739b2d6f8e0c4a15739",
};

const iraPartners = [
  {
    partnerType: "iJoin",
    displayName: "iJoin",
    setupType: "partnership",
    dataIds: {
      flagCheckbox: "bb91bdd57f8e5f48c30a06a0045d12e9",
      isPartnerField: "ea51a78e5ca339d93dff015f9f19394f",
      appliesToAllPlansYes: "9640f44ffe79bab46fd3ad727c1f9ca3",
      appliesToAllPlansNo: "3128c210230b9df3e725afdf149349b4",
      adminFeePercentageOf: "a847e98b23d21ddda7175aeaebd9bf61",
      minimumAssetBalance: "33bdde515666f86fa44454b1a4606992",
      percentageOfSpread: "74150993983557feba9f9f5c3b3c2dc0",
      setupFeePercentageOf: "22b8ed1a8e8dcea3c88f99e2788c3707",
      setupFeeAmount: "2fb4f5231e84095ae7033e944c74520d",
      setupFeeMethodToggle: "bd7d022d3d52e8371d693bde0a4311b1",
    },
  },
  {
    partnerType: "planNotice",
    displayName: "Plan Notice",
    setupType: "reward",
    dataIds: {
      flagCheckbox: "8a69aa431f6b97c818a5c6bb62fd5238",
      isPartnerField: "e4abd99bd4689da5096b001fb6842b1d",
      appliesToAllPlansYes: "24981763ce11f70be0c59b447d502abf",
      appliesToAllPlansNo: "f4e6ff56b30710ffad49a4a19efe1812",
      minimumAssetBalance: "4114fa9ddc7fbb718e42df5899a4300a",
      rewardAmount: "055ea8dac10ebe22cf60eee0ad90df32",
    },
  },
  {
    partnerType: "ssAndC",
    displayName: "SS&C",
    setupType: "partnership",
    dataIds: {
      flagCheckbox: "e248aa02db8a2118d2ff20dd84039a1c",
      isPartnerField: "8811abd04c8b453b1e703257c4e292bc",
      appliesToAllPlansYes: "a57bfd593198632fdc8ec07661d0a388",
      appliesToAllPlansNo: "719744cec0f3bcfc24efbd189522f574",
      adminFeePercentageOf: "cbebe473df15d8cd1a9f8cee9882dcec",
      minimumAssetBalance: "99e2f6c10e17e1ec94a4bb85417c9caf",
      percentageOfSpread: "54ab609a283ded945829ca48517154a3",
      setupFeePercentageOf: "2b7e55b6974be78a5076ed62a1c59274",
      setupFeeAmount: "aa2f51f23548c1fb3790f78169d76025",
      setupFeeMethodToggle: "fc622cefcf903c07bd7aba0a6c4b3b21",
    },
  },
];

export default iraPartners;
